var clPrefix = 'ak-renderer-';
export var RendererCssClassName = {
    DOCUMENT: clPrefix + "document",
    EXTENSION: clPrefix + "extension",
    EXTENSION_OVERFLOW_CONTAINER: clPrefix + "extension-overflow-container",
    NUMBER_COLUMN: clPrefix + "table-number-column",
    SORTABLE_COLUMN: clPrefix + "tableHeader-sortable-column",
    SORTABLE_COLUMN_NOT_ALLOWED: clPrefix + "tableHeader-sortable-column__not-allowed",
    SORTABLE_COLUMN_ICON: clPrefix + "tableHeader-sorting-icon",
    SORTABLE_COLUMN_NO_ORDER: clPrefix + "tableHeader-sorting-icon__no-order",
};
//# sourceMappingURL=consts.js.map